import React from "react";
import { Box, Button, MenuItem, Select, Typography } from "@mui/material";
import { formatWeekRange } from "../utils/buildWeeklySummaryModel";

export default function WeekSelector({
  summaries = [],
  selectedId = "",
  onSelect,
  onPrevious,
  onNext,
  hasPrevious,
  hasNext,
}) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: { xs: "flex-start", md: "center" },
        justifyContent: "space-between",
        gap: 2,
        flexDirection: { xs: "column", md: "row" },
      }}
    >
      <Box>
        <Typography variant="h3" sx={{ fontSize: { xs: "2rem", md: "2.4rem" }, fontWeight: 800, letterSpacing: -1.2 }}>
          Weekly Summary
        </Typography>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, width: { xs: "100%", md: "auto" } }}>
        <Button variant="outlined" onClick={onPrevious} disabled={!hasPrevious} sx={{ textTransform: "none", borderRadius: "14px" }}>
          Prev
        </Button>
        <Select
          value={selectedId}
          onChange={(event) => onSelect?.(String(event.target.value))}
          size="small"
          sx={{
            minWidth: 220,
            borderRadius: "14px",
            backgroundColor: "#fff",
          }}
        >
          {summaries.map((item) => (
            <MenuItem key={item.id} value={String(item.id)}>
              {formatWeekRange(item.week_start_date, item.week_end_date)}
            </MenuItem>
          ))}
        </Select>
        <Button variant="outlined" onClick={onNext} disabled={!hasNext} sx={{ textTransform: "none", borderRadius: "14px" }}>
          Next
        </Button>
      </Box>
    </Box>
  );
}
